import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '../element-variables.scss'
import ECharts from 'vue-echarts'
import 'echarts'

import zhCn from 'element-plus/es/locale/lang/zh-cn'

const app = createApp(App)
app.use(ElementPlus, {
  locale: zhCn,
})

app.component('ECharts', ECharts)

app.use(store)
app.use(router)
app.mount('#app')
